module.exports = __webpack_public_path__ + "3b8fd49.woff2";